import { render } from "./portal-header.vue?vue&type=template&id=91897a16&scoped=true"
import script from "./portal-header.vue?vue&type=script&lang=js"
export * from "./portal-header.vue?vue&type=script&lang=js"

import "./portal-header.vue?vue&type=style&index=0&id=91897a16&scoped=true&lang=css"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91897a16"]])

export default __exports__